import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function PortalLogin() {
  const { loginPortal } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await loginPortal(password); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#2d2d2d', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '1rem'
    }}>
      {/* Fondo decorativo */}
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none',
        background: 'radial-gradient(ellipse 60% 50% at 50% 100%, rgba(229,56,18,0.15) 0%, transparent 70%)'
      }} />

      <div style={{
        background: '#fff', borderRadius: 8, padding: '2.5rem 2rem',
        width: '100%', maxWidth: 380, position: 'relative', zIndex: 1,
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="/logo.png"
            alt="Brokalia"
            style={{ height: 32, objectFit: 'contain' }}
            onError={e => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <span style={{
            display: 'none', fontFamily: 'Heebo, sans-serif',
            fontSize: 26, fontWeight: 700, color: '#E53812'
          }}>brokalia</span>
        </div>

        <h2 style={{
          fontFamily: 'Heebo, sans-serif', fontSize: 20, fontWeight: 700,
          textAlign: 'center', marginBottom: 6, color: '#0045b7'
        }}>Portal de bienvenida</h2>
        <p style={{
          fontFamily: 'Heebo, sans-serif', fontSize: 13, color: '#888',
          textAlign: 'center', marginBottom: '1.75rem', lineHeight: 1.6
        }}>
          Acceso exclusivo para el equipo de Brokalia.<br />
          Introduce la contraseña que te han proporcionado.
        </p>

        {error && (
          <div style={{
            background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca',
            borderRadius: 3, padding: '9px 12px', marginBottom: 14,
            fontSize: 13, fontFamily: 'Heebo, sans-serif'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <input
              type="password"
              placeholder="Contraseña de acceso"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoFocus
              style={{
                width: '100%', background: '#f5f5f5', border: '1.5px solid #e8e8e8',
                borderRadius: 3, padding: '11px 14px', fontSize: 14,
                fontFamily: 'Heebo, sans-serif', color: '#2d2d2d', outline: 'none',
                boxSizing: 'border-box', transition: 'border-color 0.18s'
              }}
              onFocus={e => e.target.style.borderColor = '#E53812'}
              onBlur={e => e.target.style.borderColor = '#e8e8e8'}
            />
          </div>
          <button
            type="submit"
            disabled={loading || !password}
            style={{
              width: '100%', background: loading || !password ? '#f0c0b5' : '#E53812',
              color: '#fff', border: '2px solid transparent', borderRadius: 2, padding: '9px',
              fontSize: 14, fontWeight: 500, fontFamily: 'Heebo, sans-serif',
              cursor: loading || !password ? 'not-allowed' : 'pointer',
              transition: 'background 0.18s'
            }}
          >
            {loading ? 'Verificando...' : 'Acceder al portal →'}
          </button>
        </form>

        <p style={{
          marginTop: '1.5rem', fontSize: 11.5, color: '#bbb',
          textAlign: 'center', fontFamily: 'Heebo, sans-serif', lineHeight: 1.6
        }}>
          Si no tienes la contraseña, contacta con el departamento de RR.HH.
        </p>
      </div>
    </div>
  );
}
